import { ref, update } from 'firebase/database'
import { db, tref } from './firebase.js'

// ── Per-team access tokens (TEST feature) ──────────────────────────────────
// Each team gets a UNIQUE, unguessable token. A deep link that carries the token
// (/play?t=<tid>&tk=<token>) opens the companion app bound to that team — no name
// or email needed, and the 128-bit random token can't be fabricated to reach
// another team. Stored two ways under the tournament:
//   flights/{fid}/teams/{teamId}/info/accessToken = <token>   (the team's token)
//   teamTokens/{token} = { flightId, teamId, teamName }        (reverse lookup)

// 128 bits of crypto randomness → 32 URL-safe hex chars. Unguessable.
export function generateTeamToken() {
  const bytes = new Uint8Array(16)
  ;(globalThis.crypto || window.crypto).getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

// Assign a token to every team that doesn't already have one, in a single
// atomic update. Existing tokens are left untouched (stable QR codes). Returns
// the number of tokens created.
export async function assignTeamTokens(tournamentId, flights) {
  const updates = {}
  let created = 0
  for (const f of flights || []) {
    for (const [teamId, team] of Object.entries(f.teams || {})) {
      if (team?.info?.accessToken) continue
      const token = generateTeamToken()
      updates[`flights/${f.id}/teams/${teamId}/info/accessToken`] = token
      updates[`teamTokens/${token}`] = { flightId: f.id, teamId, teamName: team?.info?.name || teamId }
      created++
    }
  }
  if (created > 0) await update(tref(`tournaments/${tournamentId}`), updates)
  return created
}

// The companion deep link for a team. The token is the secret; the tournament id
// is not (it just scopes the reverse lookup to a readable path).
export function teamPlayLink(origin, tournamentId, token) {
  return `${origin}/play?t=${encodeURIComponent(tournamentId)}&tk=${encodeURIComponent(token)}`
}
